var map = {
	"./Tab/EcomTabPane.vue": "./src/components/globals/UI/Tab/EcomTabPane.vue",
	"./Tab/EcomTabs.vue": "./src/components/globals/UI/Tab/EcomTabs.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/globals/UI sync recursive Ecom[(A-Z)%7C(a-z)]\\w+\\.(vue%7Cjs)$";